import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";

import { getCookie, userSessionExpired } from "./auth";
const Order = () => {
  const history = useHistory();
  const addOrder = (data) => {
    return fetch(`${API}/orders`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const updateOrder = (role, Id) => {
    return fetch(`${API}/orders/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(role),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  
  const updateOrderProduct = (role, Id) => {
    return fetch(`${API}/orders/orderProduct/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(role),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const updateOrderStatus = (status, Id) => {
    return fetch(`${API}/orders/status/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(status),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const updateOrderProductsStatus = (items,id) => {
    return fetch(`${API}/orders/product-status/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(items),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const updateOrderCustomer= (item,id) => {
    return fetch(`${API}/orders/customer/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(item),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };


  const OrderAssigned= (user, Id) => {
    return fetch(`${API}/orders/assign/${Id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify(user),
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewShipmentOrders = (Id) => {
    return fetch(`${API}/orders/shipment`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  
  const viewUserShipmentOrders = (Id) => {
    return fetch(`${API}/orders/user-shipment`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewOrderProducts = (Id) => {
    return fetch(`${API}/orders/order-products`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };

  const viewOrder = (Id) => {
    return fetch(`${API}/orders/${Id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  
  const viewCustomerOrders = (Id) => {
    return fetch(`${API}/orders/customer/${Id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const deleteOrder = (Id) => {
    return fetch(`${API}/orders/${Id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const deleteMainOrder = (Id) => {
    return fetch(`${API}/orders/order/${Id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllOrders = () => {
    return fetch(`${API}/orders`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllPriceOrders = (customerName,status,startDate,endDate,sku) => {
    return fetch(`${API}/orders/price?customer=${customerName}&status=${status}&sku=${sku}&startDate=${startDate}&endDate=${endDate}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewOrderProductsPrice = (sku,startDate,endDate,statusType) => {
    return fetch(`${API}/orders/order-products/price?sku=${encodeURIComponent(sku)}&startDate=${startDate}&endDate=${endDate}&statusType=${statusType}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllOrdersWithPages = (page,limit,searchQuery,customer,status,sku,startDate, endDate,type) => {
    console.log(customer,status)
    return fetch(`${API}/orders/pages/?page=${page}&limit=${limit}&search=${searchQuery}&customer=${customer}&status=${status}&sku=${sku}&startDate=${startDate}&endDate=${endDate}&type=${type}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  const viewAllOrderProductsWithPages = (page,limit,sku,startDate, endDate,statusType) => {
    return fetch(`${API}/orders/order-products/pages/?page=${page}&limit=${limit}&&sku=${encodeURIComponent(sku)}&startDate=${startDate}&endDate=${endDate}&statusType=${statusType}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };
  return {
    addOrder,
    viewOrder,
    updateOrderStatus,
    updateOrder,
    updateOrderProduct,
    viewAllOrders,
    deleteMainOrder,
    deleteOrder,
    OrderAssigned,
    updateOrderProductsStatus,
    viewShipmentOrders,
    viewUserShipmentOrders,
    updateOrderCustomer,
    viewOrderProducts,
    viewCustomerOrders,
    viewAllOrdersWithPages,
    viewAllPriceOrders,
    viewAllOrderProductsWithPages,
    viewOrderProductsPrice
  };
};

export default Order;
